import React from 'react';

export function Card({ as: Tag = 'section', className = '', title, children }) {
  return (
    <Tag className={`ui-card ${className}`.trim()}>
      {title ? (
        <div className="ui-card-header">
          <h2 className="ui-card-title">{title}</h2>
        </div>
      ) : null}
      <div className="ui-card-body">
        {children}
      </div>
    </Tag>
  );
}
